import { LoginTab } from "@/components/auth/LoginTab";
import { RegisterTab } from "@/components/auth/RegisterTab";
import { Header } from "@/components/SiteUI";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";


const AuthPage = () => {
    const params = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (params[0].get("token")) {
            localStorage.setItem("access_token", params[0].get("token"));
            navigate("/profile");
        }

        if (localStorage.getItem("access_token")) {
            navigate("/profile");
        }
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <Header />
            <Card className="w-full max-w-md">
                <CardHeader>
                    <CardTitle>Добро пожаловать</CardTitle>
                    <CardDescription>Войдите в свой аккаунт или создайте новый</CardDescription>
                </CardHeader>
                <CardContent>
                    <Tabs defaultValue="login" className="w-full">
                        <TabsList className="grid w-full grid-cols-2">
                            <TabsTrigger value="login">Вход</TabsTrigger>
                            <TabsTrigger value="register">Регистрация</TabsTrigger>
                        </TabsList>

                        <LoginTab />
                        <RegisterTab />
                    </Tabs>
                </CardContent>
            </Card>
        </div>
    )
}

export default AuthPage;